import React from 'react';
import { Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import { FormGroupRow } from '../../../../../../common/components';
import { required } from 'redux-form-validators';
import TextArea from '../../../../../content/components/TextArea';
import ReactMarkdown from 'react-markdown';

const TextAreaRow = ({ label, input }) => {
  return (
    <FormGroupRow label={label} labelSize={12} fieldSize={12}>
      <Field
        name={input.name}
        type="text"
        validate={required({ message: 'Cannot be empty' })}
        label={'Message:'}
        labelSize={12}
        fieldSize={12}
        component={TextArea}
      />
    </FormGroupRow>
  );
};
const Markdown = ({ label, input }) => (
  <FormGroupRow label={label} labelSize={12} fieldSize={12}>
    <ReactMarkdown source={input.value}/>
  </FormGroupRow>
);

const Message = ({
    name,
    coverLevels,
    isViewOnly
  }) => {

    if (coverLevels) {
      return (
        <>
          {coverLevels.map((coverLevel) => (
              <Col sm={5}>
                <Field
                  name={`${name}.display_name[${coverLevel}]`}
                  label={`${coverLevel} Message:`}
                  labelSize={12}
                  fieldSize={12}
                  component={isViewOnly ? Markdown : TextAreaRow}
                  disabled={isViewOnly}
                />
              </Col>
            )
          )}
        </>
      );
    }
    return (
      <Col sm={5}>
        <Field
          name={`${name}.display_name`}
          validate={required({ message: 'Cannot be empty' })}
          label={'Message:'}
          labelSize={12}
          fieldSize={12}
          component={isViewOnly ? Markdown : TextAreaRow}
          disabled={isViewOnly}
        />
      </Col>
    );
  }
;
const OptionAdvisoryMessage = ({
  input,
  isViewOnly,
  coverLevels
}) => {
  const name = input.name;
  return (
    <>
      <Message
        name={name}
        coverLevels={coverLevels}
        isViewOnly={isViewOnly}
      />
    </>
  );
};

export default OptionAdvisoryMessage;
